import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const socialNetwork = {
    name: 'Social Network',
    slug: 'social-network',
    description: 'Geographic targeted Social network used for finding friends, uploading photos, following users, writing posts etc.',
    cover: {
        url: `${PUBLIC_URL}/portfolio/social-network/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by natanaelginting / Freepik'
        }
    },
    prominentColor: 'rgb(7,18,55)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/social-network/networking.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/social-network/earth.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by rawpixel.com / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/social-network/social-network.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/social-network/laptop.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Jannoon028 / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/social-network/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by natanaelginting / Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Awards',
            description: 'Award winner startup (Dubai 2009).',
        } as PieceDescription,
        {
            type: 'description',
            title: 'Role',
            description: 'Full-Stack developer',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['PHP', 'Kohana', 'Neo4j', 'Memcached', 'MySQL'],
        } as PieceUnorderedList,
    ],
};

export default socialNetwork;


// WEBPACK FOOTER //
// ./src/store/portfolio/social-network.tsx